/* eslint-disable react/no-array-index-key */
/* eslint-disable react/forbid-prop-types */
import React from 'react';
import { Constants } from '@pwc/pwc-deals-web-common';
import PropTypes from 'prop-types';
import { isLastNPeriodLabel } from '../../../../../common/services/textService';
import AdjustmentControlsColumn from '../AdjustmentControlsColumn';
import FinancialValue from '../FinancialValue';

const AdjustmentGroupWorkingCapitalContribution = ({
  rowDescription,
  totals,
  timePeriods,
  isTotalsRowStyle,
  documentCode,
  isPublishMode,
}) => {
  const isNwcTable = documentCode === Constants.NET_WORKING_CAPITAL;

  return (
    <tr
      role="row"
      className={`group-capital-contribution${
        isTotalsRowStyle ? ' totals-row' : ''
      }`}
      data-testid="adjustment-group-capital-contribution"
    >
      <th role="rowheader" scope="row" className="row-description">
        {rowDescription}
      </th>

      {timePeriods.map((timePeriodInput, index) => {
        const timePeriod = timePeriodInput.toString();
        const isLastNPeriod = isLastNPeriodLabel(timePeriod);
        const showColumnHighlight = isNwcTable && isLastNPeriod;

        return (
          <FinancialValue
            key={`${timePeriod}-${index}`}
            text={totals[timePeriod]}
            showColumnHighlight={showColumnHighlight}
          />
        );
      })}

      {!isPublishMode && <AdjustmentControlsColumn />}
    </tr>
  );
};

AdjustmentGroupWorkingCapitalContribution.propTypes = {
  rowDescription: PropTypes.string,
  totals: PropTypes.object,
  timePeriods: PropTypes.arrayOf(
    PropTypes.oneOfType([PropTypes.string, PropTypes.number])
  ).isRequired,
  isTotalsRowStyle: PropTypes.bool,
  documentCode: PropTypes.string.isRequired,
  isPublishMode: PropTypes.bool,
};

AdjustmentGroupWorkingCapitalContribution.defaultProps = {
  rowDescription: '',
  totals: {},
  isTotalsRowStyle: false,
  isPublishMode: false,
};

export default AdjustmentGroupWorkingCapitalContribution;
